import { useCyberMondayEnabled } from "../useCyberMondayEnabled/useCyberMondayEnabled";
import { useFlippers } from "../useFlippers/useFlippers";

const useWholesalePromotionEnabled = (isWholesaleEnabled: boolean = true) => {
  const { isCyberMondayEnabled, loading } = useCyberMondayEnabled(isWholesaleEnabled);
  const [isCheckoutV2Enabled] = useFlippers("lighthouse_wholesale_checkout_v2");

  return [isWholesaleEnabled && (isCyberMondayEnabled || isCheckoutV2Enabled), loading];
};

export { useWholesalePromotionEnabled };
